//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IEligibleUser } from '@apis/publish/publishApiModels';
import { serializedSessionFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

function publishFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> {
  return serializedSessionFetch(`/api/publish${endpoint}`, init);
}

/**
 * Gets the list of all users that can be targets for instagram post scheduling.
 * This is basically a list of users who have a registered mobile device on this client.
 *
 * Requires the 'publish:schedule_instagram_item' permission
 */
export async function getInstagramSchedulingEligibleUsers(
  init?: RequestInit,
): Promise<IEligibleUser[]> {
  const res = await publishFetch('/instagram-scheduling/eligible-users', init);
  return res.json();
}
